import {middlewareWrapper} from "utils/middlewareUtils";
import {showMenu} from "utils/menuUtils";
import {shownMenu, SHOW} from 'modules/Common/reducers/menu';

export default () => {
    return [
        middlewareWrapper(show)
    ]

    function show(store, next, action) {
        if (action.type === SHOW) {
            showMenu();
            store.dispatch(shownMenu());
        }

        return next(action);
    }
}


// WEBPACK FOOTER //
// ./modules/Common/middleware/menuEvents.js